import { KYMW2700Model } from '../kymw2700.model';
import { KYMW2700GetCatalogPageProgressModel } from '../vo/kymw2700-get-catalog-page-progress.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 基版コピー・フェーズ管理画面　現在フェーズ情報を取得するサービス
 *
 * @export GetCatalogPhaseInfoService
 * @class GetCatalogPhaseInfoService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetCatalogPhaseInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW2700Model}
   * @memberof GetCatalogPhaseInfoService
   */
  private model: KYMW2700Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW2700GetCatalogPageProgressModel}
   * @memberof GetCatalogPhaseInfoService
   */
  private vo: KYMW2700GetCatalogPageProgressModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetCatalogPhaseInfoService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCatalogPhaseInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType
      }
    });;
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetCatalogPhaseInfoService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW2700Model>model;
    this.vo = <KYMW2700GetCatalogPageProgressModel>vo;
    this.successFunc = successFunc;
    this.send('getCatalogPhaseInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCatalogPhaseInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
